/*!
 * Copyright © 2026 Nail Alliance - North America, Inc.
 * Authors: See snippets/copyright-notices.liquid in the theme.
 * No other use is authorized without a written contract.
 */

(() => {
  class SoftGelRefillSelector extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.buttons = [...this.querySelectorAll('[data-refill-index]')];
      this.cards = [...this.querySelectorAll('[data-refill-card]')];

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.select(Number(button.dataset.refillIndex)), { signal });
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const currentIndex = Number(button.dataset.refillIndex);
          const nextIndex = (currentIndex + direction + this.buttons.length) % this.buttons.length;
          this.select(nextIndex);
          this.buttons[nextIndex]?.focus();
        }, { signal });
      });

      const selectedIndex = this.buttons.findIndex((button) => button.getAttribute('aria-selected') === 'true');
      this.select(Math.max(selectedIndex, 0));
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    select(index) {
      const card = this.cards[index];
      if (!card) return;
      this.buttons.forEach((button, buttonIndex) => {
        button.setAttribute('aria-selected', String(buttonIndex === index));
        button.tabIndex = buttonIndex === index ? 0 : -1;
      });
      this.cards.forEach((candidate, cardIndex) => {
        candidate.hidden = cardIndex !== index;
      });
    }
  }

  if (!customElements.get('soft-gel-refill-selector')) {
    customElements.define('soft-gel-refill-selector', SoftGelRefillSelector);
  }
})();
